import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSales } from 'app/mocks/data/transactions/sales'
import { allUsersKonsole } from 'app/mocks/data/users/konsole'

import { api } from 'app/utils/constants'

import {
    Refund,
    RefundPayloadBackend,
    StatusRefund,
} from 'app/types/transactions/refund'

export const createRefund = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.transactions.sales.REFUND}`,
    async ({ request, params }) => {
        const payload = await request.json()
        const payloadParsed = RefundPayloadBackend.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const saleFound = allSales.find(
            (sale) => sale.id.toString() === params.id,
        )

        const amount = payloadParsed.data.products.reduce(
            (total, product) => total + product.amount,
            0,
        )

        return HttpResponse.json<Refund>({
            ...payloadParsed.data,
            id: 999,
            date: new Date().toISOString(),
            status: StatusRefund.enum.APPROVED,
            amount,
            author: allUsersKonsole[0],
            sale: saleFound.id,
        })
    },
)
